import { render, staticRenderFns } from "./ChemUCI1LDQ4S1Q10.vue?vue&type=template&id=36921e0e&scoped=true&"
import script from "./ChemUCI1LDQ4S1Q10.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LDQ4S1Q10.vue?vue&type=script&lang=js&"
import style0 from "./ChemUCI1LDQ4S1Q10.vue?vue&type=style&index=0&id=36921e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36921e0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VRadio,VRadioGroup,VSelect})
